import {getPackageHistoryForParentContainer} from "../../../../commons/api/GetPackageHistoryForParentContainerResults.js";
import {batchGetPackageSummaryForPackageId} from "../../../../commons/api/BatchGetPackageSummaryResults.js";
import {convertWeightToKilograms} from "../safetyReport/Util";

export const getContainerDetail = async (nodeId, containerId, startTime, endTime, eventTime, routeCode, containerType) => {
    let packageHistoryResult = await getPackageHistoryForParentContainer(containerId, nodeId, 100, null, startTime, endTime)
    let packageInContainer = packageHistoryResult.packageHistory
    let nextToken = packageHistoryResult.nextToken
    while (nextToken) {
        let nextPagePackageHistoryResult = await getPackageHistoryForParentContainer(containerId, nodeId, 100, nextToken, startTime, endTime)
        nextToken = nextPagePackageHistoryResult.nextToken
        packageInContainer = {...packageInContainer, ...nextPagePackageHistoryResult.packageHistory}
    }
    let trackingIds = packageInContainer.map((pp) => pp.trackingId)
    let packageDetails = await batchGetPackageSummaryForPackageId(trackingIds)
    let result = packageDetails.reduce(
        (acc, curr) => {
            const currPackageWeight = convertWeightToKilograms(
                curr.packageWeight.value,
                curr.packageWeight.unit
            );
            return {
                max: Math.max(acc.max, currPackageWeight),
                sum: acc.sum + currPackageWeight,
                count: acc.count + 1,
                bagPickLocation: curr.assignedSortZone
            };
        },
        {max: -Infinity, sum: 0, count: 0, bagPickLocation: ""}
    );
    return new BagData(
        containerId,
        routeCode,
        result.count,
        result.sum,
        result.max,
        result.sum / result.count,
        eventTime,
        result.bagPickLocation
    );
}

class BagData {
    constructor(
        bagId,
        routeCode,
        totalPackage,
        totalWeight,
        maxPackageWt,
        avgPackageWt,
        eventTime,
        bagPickLocation

    ) {
        this.bagId = bagId;
        this.routeCode = routeCode;
        this.totalPackage = totalPackage;
        this.totalWeight = totalWeight;
        this.maxPackageWt = maxPackageWt;
        this.avgPackageWt = avgPackageWt;
        this.eventTime = eventTime;
        this.bagPickLocation = bagPickLocation
    }
}




// WEBPACK FOOTER //
// ./src/components/detailPages/associateDetails/safetyReport/GetContainerDetail.js